module.exports = __webpack_public_path__ + "static/media/67 - Laurent Voulzy - Le Coeur Grenadine.0f426f6b.mp3";